import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./component/Header/Header";
import FooterSection from "./component/Footer/Footer";
import AllPackeges from "./pages/Packeges/AllPackeges";
import Home from "./pages/Home/Home";
import PackegDetails from "./pages/PackegDetails/PackegDetails";
import GalleryPage from "./pages/Gallery/GalleryPage";
import BlogLandingPage from "./pages/Blog/BlogLandingPage";
import BlogDetailsPage from "./pages/Blog/BlogDetailsPage";
import ContactUsPage from "./pages/Blog/ContactUsPage";
import AboutUs from "./pages/AboutUs/AboutUs";
import BASE_URL from "./component/commanfile";
import axios from "axios";
import { Button, Form, Modal } from "react-bootstrap";
import { RiMessage3Fill } from "react-icons/ri";
import { Carousel } from "react-bootstrap";
import { FaEdit } from "react-icons/fa";

function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppContent() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [webSettings, setWebSettings] = useState(null);
  const [webTours, setWebTours] = useState([]);
  const location = useLocation();
const [adsData, setAdsData] = useState([]);
const [showAdsModal, setShowAdsModal] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    mobile_number: "",
    customerNotes: "",
    email: "",
    type: "custom"
  });
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const res = await axios.post(
        `${BASE_URL}api/tourinquery`,
        {
          name: formData.name,
          mobileNumber: formData.mobile_number,
          customerNotes: formData.customerNotes,
          email: formData.email,
          type: "custom"
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );


        setSuccess("Inquiry sent successfully! Our team will contact you soon.");
        setFormData({ name: "", mobile_number: "", customerNotes: "", email: "", type: "custom" });

      setTimeout(() => {
        setShowModal(false);
          setFormData({ name: "", mobile_number: "", customerNotes: "", email: "", type: "custom" });
          setSuccess("");
      }, 3000);
      
    } catch (err) {
      console.error("Tour inquiry error", err);
      setError("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const hideQuickInquiry =
    location.pathname.startsWith("/tour-details/");

  const [menus, setMenus] = useState([]);
  const [tourSector, setTourSector] = useState([]);

  console.log("menus", menus, tourSector, webSettings);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 200);
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const fetchHeaderData = async () => {
      try {
        const [menuRes, tourRes, settingsRes] = await Promise.all([
          axios.get(`${BASE_URL}api/web-menu`),
          axios.get(`${BASE_URL}api/web-tours`),
          axios.get(`${BASE_URL}api/web-settings`)
        ]);

        setMenus(menuRes.data || []);
        setWebTours(tourRes?.data?.sectors  || []);
        const data = tourRes?.data?.sectors || [];
        const grouped = data.reduce((acc, tour) => {
          let typeObj = acc.find(i => i.type === tour.tour_type_name);
          if (!typeObj) {
            typeObj = { type: tour.tour_type_name, sector: [] };
            acc.push(typeObj);
          }

          let sectorObj = typeObj.sector.find(
            s => s.sectorName === tour.sector_name
          );

          if (!sectorObj) {
            sectorObj = {
              sectorName: tour.sector_name,
              sectorId: tour.sector_id,
              tours: []
            };
            typeObj.sector.push(sectorObj);
          }

          sectorObj.tours.push(tour);
          return acc;
        }, []);

        setTourSector(grouped);
        setWebSettings(settingsRes.data);
      } catch (err) {
        console.error("Header data error", err);
      }
    };

    fetchHeaderData();
  }, []);

  useEffect(() => {
    function handleScroll() {
      setIsScrolled(window.scrollY > 200);
    }

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const headerStyle = {
    position: "sticky",
    top: 0,
    zIndex: 9999,
    width: "100%",
    transition: "background-color 0.3s ease, box-shadow 0.3s ease",
  };


  const mainContentStyle = {
    paddingTop: "0px",
  };
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [packages, setPackages] = useState([]); 
        const [hotPackages, setHotPackages] = useState([]); 

  const [homeImages, setHomeImages] = useState([]); 
  const [showModal, setShowModal] = useState(false);
  const theme = {
    primary: "#8f0909",
    dark: "#082e5e",
    light: "#f8f9fa"
  };

  const styles = {
    hero: {
      background: `linear-gradient(rgba(58, 57, 121, 0.8), rgba(10, 29, 55, 0.9)), 
                   url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?auto=format&fit=crop&w=1600&q=80')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      padding: "100px 0 140px", 
      textAlign: "center",
      position: "relative",
      width: "100%"
    },

    infoCard: {
      border: "none",
      borderRadius: "24px",
      padding: "30px",
      height: "100%",
      backgroundColor: "#fff",
      boxShadow: "0 15px 35px rgba(0,0,0,0.08)", 
      transition: "transform 0.3s ease",
      position: "relative",
      zIndex: 5 
    },
    iconBox: {
      width: "55px",
      height: "55px",
      borderRadius: "15px",
      backgroundColor: "#fff1f1",
      color: theme.primary,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1.4rem",
      marginBottom: "20px"
    },
    input: {
      borderRadius: "12px",
      padding: "14px 20px",
      border: "1px solid #eee",
      backgroundColor: "#fcfcfc",
      fontSize: "0.95rem"
    }
  };
useEffect(() => {
  const fetchAdvertisements = async () => {
    try {
      const res = await axios.get(`${BASE_URL}api/web-advertisement`);
      if (res.data && res.data.length > 0) {
        setAdsData(res.data);      // store all ads
        setShowAdsModal(true);     // show popup immediately
      }
    } catch (err) {
      console.error("Advertisement fetch error:", err);
    }
  };

   const fetchPackages = async () => {
        try {
          const response = await axios.get(`${BASE_URL}api/web-all-tours`); // Replace with your API endpoint
          setPackages(response?.data?.allTours);
          setHotPackages(response?.data?.trading)
        } catch (error) {
          console.error("Error fetching packages:", error);
        }
      };
  
         const fetchPackagesApi = async () => {
        try {
          const response = await axios.get(`${BASE_URL}api/web-dashboard`); // Replace with your API endpoint
          setHomeImages(response?.data);
        } catch (error) {
          console.error("Error fetching packages:", error);
        }
      };

  fetchAdvertisements();
  
    fetchPackages();
    fetchPackagesApi();
}, []);
const navigate = useNavigate();

const handleAdClick = (ad) => {
  if (ad.type === "sector") {
    navigate(`/allpackeges/${ad.selectedpackageandsector}`);
  } else {
    // Default or other types
    const cleanId = ad.selectedpackageandsector.replace("tour-", "");
    navigate(`/tour-details/${cleanId}`);
  }
  setShowAdsModal(false);
};
  return (
    <div className="App">
      <ScrollToTopOnRouteChange />
      <div style={mainContentStyle}>

        <div style={headerStyle}>
          <Header isScrolled={isScrolled} menus={menus} tourSector={tourSector} />
        </div>

        {!hideQuickInquiry && (
          <div style={{
            position: "fixed",
            right: "0px",
            bottom: "50vh",
            zIndex: 99999,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "15px"
          }}>

     

            <div
              onClick={() => setShowModal(true)}
              style={{
                backgroundColor: "#ff5722", 
                color: "#ffffff",
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "24px",
                cursor: "pointer",
                boxShadow: "0 10px 25px rgba(255, 87, 34, 0.4)",
                border: "none",
                position: "relative"
              }}
            >
<FaEdit />

              <span style={{
                position: "absolute",
                top: "0px",
                right: "0px",
                backgroundColor: "#082e5e",
                width: "20px",
                height: "20px",
                borderRadius: "50%",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "2px solid #fff"
              }}>
                +
              </span>
            </div>
          </div>
        )}

         {!hideQuickInquiry && (
          <div style={{
            position: "fixed",
            right: "10px",
            bottom: "20px",
            zIndex: 99999,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "15px"
          }}>

            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {webSettings?.socialMedia?.map((item, index) => (
                <div
                  key={index}
                  onClick={() => window.open(item.link, "_blank")}
                  style={{
                    cursor: "pointer",
                    width: "42px",
                    height: "42px",
                    backgroundColor: "#ffffff",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                    border: "1px solid #eee"
                  }}
                >
                  <img
                    src={`${item.iconLink}`}
                    alt={item.type}
                    style={{ width: "20px", height: "20px", objectFit: "contain" }}
                  />
                </div>
              ))}
            </div>

        
          </div>
        )}
        <div>
          <Routes>
            <Route path="/" element={<Home webTours={webTours} packages={packages} hotPackages={hotPackages} homeImages={homeImages} />} />
            <Route path="/allpackeges/:id" element={<AllPackeges webdata={webSettings}/>} />
            <Route path="/tour-details/:id" element={<PackegDetails  />} />
            <Route path="/moments" element={<GalleryPage />} />
            <Route path="/blog" element={<BlogLandingPage />} />
            <Route path="/blog/:id" element={<BlogDetailsPage />} />
            <Route path="/contact-us" element={<ContactUsPage webSettings={webSettings} />} />
            <Route path="/about-us" element={<AboutUs webSettings={webSettings} />} />
          </Routes>
          <FooterSection
            footerData={webSettings}
            chardhamData={menus}
            tourSector={tourSector}
          />
          <Modal
            show={showModal && !hideQuickInquiry} 
            onHide={() => setShowModal(false)}
            centered
            dialogClassName="custom-modal"
          >


            <div style={{ ...styles.infoCard, borderTop: `8px solid ${theme.primary}`, position: "sticky", top: "20px" }}>
              <div className="mb-4">
                <h4 className="fw-bold mb-1">Quick Inquiry</h4>
                <p className="text-muted small">Fill out the form and we'll reply soon.</p>
              </div>
              <Form onSubmit={handleSubmit}>
{/* {!success || !error &&  */}
       
{/* } */}


                  {success ? <h4 className="fw-bold mb-1 text-success">{success}</h4> :          <>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold text-muted">Full Name</Form.Label>
                  <Form.Control
                    style={styles.input}
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold text-muted">Mobile Number</Form.Label>
                  <Form.Control
                    style={styles.input}
                    type="tel"
                    name="mobile_number"
                    value={formData.mobile_number}
                    onChange={handleChange}
                    placeholder="Enter your mobile number" // 🔹 placeholder

                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="small fw-bold text-muted">Email Address</Form.Label>
                  <Form.Control
                    style={styles.input}
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email address" // 🔹 placeholder
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label className="small fw-bold text-muted">Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    style={styles.input}
                    name="customerNotes"
                    value={formData.customerNotes}
                    onChange={handleChange}
                    placeholder="Enter your message" // 🔹 placeholder
                    required
                  />
                </Form.Group>

              

                <Button
                  type="submit"
                  className="w-100 py-3 border-0"
                  style={{ borderRadius: "15px", fontWeight: "700", backgroundColor: "#082e5e" }}
                  disabled={loading}
                >
                  {loading ? "Sending..." : "SEND MESSAGE"}
                </Button>
                </>}
                {error && <p className="text-danger small">{error}</p>}
              </Form>

            </div>
          </Modal>
<Modal
  show={showAdsModal}
  onHide={() => setShowAdsModal(false)}
  centered
  size="lg"
  className="modern-ads-modal"
>
  <Modal.Body className="p-0 position-relative">
    {/* Close Button Overlay */}
    <button className="custom-close-btn" onClick={() => setShowAdsModal(false)}>×</button>
    
    {adsData.length > 0 && (
      <Carousel interval={5000} fade indicators={adsData.length > 1} controls={adsData.length > 1}>
        {adsData.map((ad, index) => (
          <Carousel.Item key={index} onClick={() => handleAdClick(ad)} style={{ cursor: 'pointer' }}>
            <div className="ad-image-container">
              {ad.image && (
                <img
                  className="d-block w-100"
                  src={`${BASE_URL}/api/image?file=${ad.image}`}
                  alt="Advertisement"
                />
              )}
              <div className="ad-overlay">
                <div className="ad-content">
                  <span className="ad-badge">Special Offer</span>
                  <h3 className="ad-title">{ad.description}</h3>
                  <button className="btn-modern-action">Explore Now</button>
                </div>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    )}
  </Modal.Body>
</Modal>

        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router basename="/">
      <AppContent />
    </Router>
  );
}

export default App;
